import NavButtons from './NavButtons';

export default NavButtons;
